
import Header from "@/components/header/header.vue";
import {  inject, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

export default {
  components: {
    Header,
  },
  setup() {
    const $http: any = inject("$http");
    //选择的省份
    let provinceList = ref();
    const usete: any = useRoute();
    const router: any = useRouter();

    const provinceFunc = async (val: String = "") => {
      let res = await $http.post_areas({
        parent_id: val ? val : "",
        size: 100,
      });
      if (res.code === 200) {
        if(sessionStorage.getItem('isFiltrate') == '1'&&usete.query.name!='county'){
          // 存在 isFiltrate 表示要筛选当前地区能上门取件的地址 筛选出支持上门的城市进行显示
          provinceList.value=  res.data.filter((item:any)=>item.area_pickup == '1')
        }else{
          provinceList.value = res.data;
        }
      }
    };

    if (usete.query.name === "county") {
      provinceFunc();
    } else {
      provinceFunc(usete.query.area_id);
    }
    const pitchLevel = (val: any): void => {  
      if (usete.query.name === "county") {
        router.push({
          path: "/address-adds",
          query: {
            area_id: val.area_id,
            area_name: val.area_name,
          },
        });
      } else {
        router.push({
          path: "/address-adds",
          query: {
            row_id: val.area_id,
            town_name: val.area_name,
            area_name: usete.query.area_name,
            area_id: usete.query.area_id,
            area_door: val.area_door,
            area_pickup: val.area_pickup,
          },
        });
      }
    };

    return {
      provinceList,
      pitchLevel,
      usete,
    };
  },
};
